import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';

import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import mapStateToProps from './reducer/mapStateToProp';
import { connect } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const queryClient = new QueryClient();
Amplify.configure(awsconfig);

function App() {
  const content = useRoutes(router);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <CssBaseline />
          {content}
        </LocalizationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default connect(mapStateToProps)(App);
